// Format number as percentage
export const formatPercent = (value: number | null | undefined, includeSign: boolean = false): string => {
  if (value === null || value === undefined) return 'N/A';

  // Multiply by 100 to convert decimal (0.75) to percentage (75%)
  const formatted = `${(value * 100).toFixed(1)}%`;
  if (includeSign && value > 0) {
    return `+${formatted}`;
  }
  return formatted;
};

// Format number as currency
export const formatCurrency = (
  value: number | null | undefined,
  currency: string = 'USD',
  includeDecimals: boolean = true
): string => {
  if (value === null || value === undefined) return 'N/A';

  const decimals = includeDecimals ? 2 : 0;

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
};

// Format large numbers with K/M suffixes
export const formatNumber = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return 'N/A';

  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(1)}M`;
  }
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1)}K`;
  }
  return value.toLocaleString();
};

// Format date
export const formatDate = (date: string | Date | null | undefined): string => {
  if (!date) return 'N/A';

  const d = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(d);
};

// Format relative time (e.g., "2 hours ago")
export const formatRelativeTime = (date: string | Date | null | undefined): string => {
  if (!date) return 'N/A';

  const d = typeof date === 'string' ? new Date(date) : date;
  const now = new Date();
  const diffMs = now.getTime() - d.getTime();
  const diffMins = Math.floor(diffMs / 60000);

  if (diffMins < 1) return 'just now';
  if (diffMins < 60) return `${diffMins} min ago`;

  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;

  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;

  return formatDate(d);
};
